<template>
  <v-layout align-start>
    <v-flex>
      <div id="app">
        <v-app id="inspire">
          <v-row justify="center">
            <v-col cols="12" sm="10" md="8" lg="12">
              <v-card ref="form">
                <v-card-text>
                  <v-col cols="12" md="12">
                    <v-alert type="info" class="subtitle-2 text-center" color="primary">CAMBIO DE CONTRASEÑA</v-alert>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-text-field v-model="contrasenia1" label="Nuevo Contraseña" required></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-text-field v-model="contrasenia2" label="Confirma Nuevo Contraseña" required></v-text-field>
                  </v-col>

                  <div align="center">
                     <v-btn color="primary" @click="cambio" >Guardar</v-btn>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="12" md="12" v-show="valida">
                      <v-row class="red--text" v-for="v in validamensaje" :key="v" v-text="v"></v-row>
                    </v-col>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-app>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      // Variable
      contrasenia1: "",
      contrasenia2: "",
      valida: 0,
      validamensaje: []
    };
  },

  methods: {
    cambio() {
      if (this.validar()) {
        return;
      }

      var qs = require('qs');
      var data = qs.stringify({
        json:
          '{"usuariopassword":"'+this.contrasenia1+'"}'
      });

      //Editar
      let me = this;
      let header = { Authorization:this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          "api/usuarios/cambio",
          data,
          configuracion
        )
        .then(function(response) {
          me.limpiar();
          me.$swal("Contraseña Actualizada con Exito");
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    limpiar() {
      this.contrasenia1 = "";
      this.contrasenia2 = "";
      this.valida = 0;
      this.validamensaje = [];
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (!this.contrasenia1) {
        this.validamensaje.push("La Nueva Contraseña esta Vacia");
      }

      if (!this.contrasenia2) {
        this.validamensaje.push("La Confirmacion Nueva Contraseña esta Vacia");
      }

      if (this.contrasenia1 != this.contrasenia2) {
        this.validamensaje.push("Las Contraseñas no son Iguales");
      }

      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    }
  }
};
</script>